module.exports = __webpack_public_path__ + "static/media/Ninjask_gaussian2.babc5718.png";